import React from "react";

import Footer from "../layout/Footer";
import Header from "../layout/Header";
import Fifth from "./sections/Fifth";
import First from "./sections/First";
import Fourth from "./sections/Fourth";
import Second from "./sections/Second";
import Third from "./sections/Third";

export default function Home() {

  return (
    <>
      <section className="font-fiexen">
        <Header />
        <First />
        <Second />
        <Third />
        <Fourth />
        <Fifth />
        <Footer />
      </section>
    </>
  );
}
